const SERVICE_ICON_BY_SLUG = {
  'railcar-cleaning': 'brush-cleaning',
  'limpieza-de-vagones-ferroviarios': 'brush-cleaning',
  'railcar-leasing': 'handshake',
  leasing: 'handshake',
  'arrendamiento-y-compra': 'handshake',
  arrendamiento: 'handshake',
  'storage-handling': 'house',
  storage: 'house',
  'almacenamiento-y-manejo': 'house',
  almacenamiento: 'house',
  transloading: 'arrow-right-left',
  transbordo: 'arrow-right-left',
  'repair-maintenance': 'wrench',
  repair: 'wrench',
  'reparacion-y-mantenimiento': 'wrench',
  reparacion: 'wrench',
  'scrap-processing': 'recycle',
  'procesamiento-de-chatarra': 'recycle',
  'remarking-stenciling': 'stamp',
  remarking: 'stamp',
  'remarcado-y-rotulado': 'stamp',
  remarcado: 'stamp',
};

const ICON_NAME_BY_KEY = {
  spray: 'brush-cleaning',
  document: 'handshake',
  split: 'arrow-right-left',
  stencil: 'stamp',
  map: 'map-pin',
  case: 'briefcase-medical',
  info: 'file-text',
  article: 'file-text',
  call: 'phone',
  arrow: 'arrow-right',
};

const THEME_DATA = (window.crmsThemeData && typeof window.crmsThemeData === 'object')
  ? window.crmsThemeData
  : {};
const MEGA_MENU_CONFIG = (THEME_DATA.megaMenu && typeof THEME_DATA.megaMenu === 'object')
  ? THEME_DATA.megaMenu
  : {};
const SECTION_CONFIG = (MEGA_MENU_CONFIG.sections && typeof MEGA_MENU_CONFIG.sections === 'object')
  ? MEGA_MENU_CONFIG.sections
  : {};
const ABOUT_FREE_CALL_URL = String(MEGA_MENU_CONFIG.aboutFreeCallUrl || '').trim();
const ABOUT_FREE_CALL_LABEL = String(MEGA_MENU_CONFIG.aboutFreeCallLabel || '').trim() || 'Book a Discovery Call';

const getPathFromUrl = (rawUrl) => {
  try {
    return new URL(rawUrl || '#', window.location.origin).pathname.replace(/\/+$/, '') || '/';
  } catch {
    return '/';
  }
};

const isExternalUrl = (rawUrl) => {
  try {
    const parsed = new URL(rawUrl || '#', window.location.origin);
    return parsed.origin !== window.location.origin;
  } catch {
    return false;
  }
};

const getSectionKey = (path) => {
  const cleaned = (path || '/').replace(/^\/+/, '');
  const segments = cleaned.split('/').filter(Boolean);

  if (!segments.length) {
    return '';
  }

  // Handle WPML language prefixes in routes (example: /es/...)
  let slug = segments[0].toLowerCase();
  if (/^[a-z]{2}$/i.test(slug) && segments.length > 1) {
    slug = segments[1].toLowerCase();
  }

  const aliases = {
    about: 'about',
    'sobre-nosotros': 'about',
    careers: 'about',
    carrera: 'about',
    carreras: 'about',
    empleo: 'about',
    empleos: 'about',
    services: 'services',
    servicios: 'services',
    locations: 'locations',
    ubicaciones: 'locations',
    'case-studies': 'case-studies',
    'casos-de-estudio': 'case-studies',
  };

  return aliases[slug] || slug;
};

const resolveSectionKeyFromUrl = (sectionUrl) => {
  const sectionPath = getPathFromUrl(sectionUrl);

  for (const [key, config] of Object.entries(SECTION_CONFIG)) {
    if (key === 'fallback' || !config || typeof config !== 'object') {
      continue;
    }

    const configuredUrl = String(config.sectionUrl || '').trim();
    if (!configuredUrl) {
      continue;
    }

    if (getPathFromUrl(configuredUrl) === sectionPath) {
      return key;
    }
  }

  return getSectionKey(sectionPath);
};

const resolveSectionConfig = (sectionKey, title, sectionUrl) => {
  const fallbackBase = (SECTION_CONFIG.fallback && typeof SECTION_CONFIG.fallback === 'object')
    ? SECTION_CONFIG.fallback
    : {};
  const base = (SECTION_CONFIG[sectionKey] && typeof SECTION_CONFIG[sectionKey] === 'object')
    ? SECTION_CONFIG[sectionKey]
    : fallbackBase;
  const baseIntro = (base.intro && typeof base.intro === 'object') ? base.intro : {};
  const fallbackIntro = (fallbackBase.intro && typeof fallbackBase.intro === 'object')
    ? fallbackBase.intro
    : {};
  const baseFeatured = (base.featured && typeof base.featured === 'object') ? base.featured : {};
  const fallbackFeatured = (fallbackBase.featured && typeof fallbackBase.featured === 'object')
    ? fallbackBase.featured
    : {};
  const resolvedSectionUrl = sectionUrl || '#';
  const resolvedCtaLabel = String(base.ctaLabel || fallbackBase.ctaLabel || title || '').trim();

  return {
    intro: {
      eyebrow: String(baseIntro.eyebrow || base.eyebrow || fallbackIntro.eyebrow || fallbackBase.eyebrow || title || '').trim(),
      title: String(baseIntro.title || fallbackIntro.title || title || '').trim(),
      body: String(baseIntro.body || base.summary || fallbackIntro.body || fallbackBase.summary || '').trim(),
      ctaLabel: String(baseIntro.ctaLabel || resolvedCtaLabel).trim(),
      ctaUrl: String(baseIntro.ctaUrl || resolvedSectionUrl).trim() || resolvedSectionUrl,
      imageUrl: String(baseIntro.imageUrl || fallbackIntro.imageUrl || '').trim(),
    },
    showFeatured: base.showFeatured === true,
    featured: {
      eyebrow: String(baseFeatured.eyebrow || fallbackFeatured.eyebrow || title || '').trim(),
      title: String(baseFeatured.title || fallbackFeatured.title || title || '').trim(),
      body: String(baseFeatured.body || fallbackFeatured.body || '').trim(),
      ctaLabel: String(baseFeatured.ctaLabel || fallbackFeatured.ctaLabel || resolvedCtaLabel).trim(),
      ctaUrl: String(baseFeatured.ctaUrl || fallbackFeatured.ctaUrl || resolvedSectionUrl).trim() || resolvedSectionUrl,
      imageUrl: String(baseFeatured.imageUrl || fallbackFeatured.imageUrl || '').trim(),
    },
  };
};

const resolveEntryIconKey = (sectionKey, entryPath) => {
  const slug = entryPath.replace(/^\/+/, '').split('/').pop() || '';

  if (sectionKey === 'services') {
    return SERVICE_ICON_BY_SLUG[slug] || 'arrow';
  }

  if (sectionKey === 'locations') {
    return 'map';
  }

  if (sectionKey === 'case-studies') {
    return 'case';
  }

  if (sectionKey === 'blog') {
    return 'article';
  }

  return 'info';
};

const resolveIconName = (iconKey) => {
  const normalizedKey = String(iconKey || '').trim().toLowerCase();
  if (!normalizedKey) {
    return 'file-text';
  }

  return ICON_NAME_BY_KEY[normalizedKey] || normalizedKey;
};

const buildEntryIcon = (iconKey) => {
  const icon = document.createElement('span');
  icon.className = 'mega-menu-entry__icon';
  icon.setAttribute('aria-hidden', 'true');

  const glyph = document.createElement('i');
  glyph.setAttribute('data-lucide', resolveIconName(iconKey));
  glyph.className = 'h-4 w-4';
  glyph.setAttribute('aria-hidden', 'true');

  icon.appendChild(glyph);
  return icon;
};

const decorateEntryLink = (link, sectionKey) => {
  if (link.dataset.megaDecorated === 'true') {
    return;
  }

  const labelText = (link.textContent || '').trim();
  const entryPath = getPathFromUrl(link.getAttribute('href') || '#');
  const forcedIcon = (link.dataset.megaIcon || '').trim();
  const iconKey = forcedIcon || resolveEntryIconKey(sectionKey, entryPath);

  link.textContent = '';
  link.appendChild(buildEntryIcon(iconKey));

  const label = document.createElement('span');
  label.className = 'mega-menu-entry__label';
  label.textContent = labelText;
  link.appendChild(label);

  if (sectionKey === 'locations') {
    const match = labelText.match(/,\s*([A-Z]{2})$/);
    if (match) {
      const region = document.createElement('span');
      region.className = 'mega-menu-entry__region';
      region.textContent = match[1];
      link.appendChild(region);
    }
  }

  link.dataset.megaDecorated = 'true';
};

const buildIntroNode = ({
  eyebrow,
  title,
  body,
  ctaLabel,
  ctaUrl,
  imageUrl,
}) => {
  const intro = document.createElement('li');
  intro.className = 'mega-menu-intro';
  if (imageUrl) {
    intro.classList.add('mega-menu-intro--visual');
    intro.style.backgroundImage = `linear-gradient(160deg, rgba(4, 10, 18, 0.62), rgba(4, 10, 18, 0.84)), url("${imageUrl}")`;
  }

  const content = document.createElement('div');
  content.className = 'mega-menu-intro__content';

  const eyebrowNode = document.createElement('span');
  eyebrowNode.className = 'mega-menu-intro__eyebrow';
  eyebrowNode.textContent = eyebrow;

  const heading = document.createElement('h4');
  heading.className = 'mega-menu-intro__title';
  heading.textContent = title;

  const text = document.createElement('p');
  text.className = 'mega-menu-intro__text';
  text.textContent = body;

  const cta = document.createElement('a');
  cta.className = 'mega-menu-intro__cta';
  cta.setAttribute('href', ctaUrl);
  cta.textContent = ctaLabel;

  content.appendChild(eyebrowNode);
  content.appendChild(heading);
  content.appendChild(text);

  intro.appendChild(content);
  intro.appendChild(cta);

  return intro;
};

const buildFeaturedNode = ({ eyebrow, title, body, ctaLabel, ctaUrl, imageUrl }) => {
  const card = document.createElement('li');
  card.className = 'mega-menu-featured';

  const media = document.createElement('div');
  media.className = 'mega-menu-featured__media';
  media.setAttribute('aria-hidden', 'true');
  if (imageUrl) {
    media.style.backgroundImage = `linear-gradient(160deg, rgba(4, 10, 18, 0.24), rgba(4, 10, 18, 0.62)), url("${imageUrl}")`;
  }

  const content = document.createElement('div');
  content.className = 'mega-menu-featured__content';

  const ctaWrap = document.createElement('div');
  ctaWrap.className = 'mega-menu-featured__cta-wrap';

  const eyebrowNode = document.createElement('span');
  eyebrowNode.className = 'mega-menu-featured__eyebrow';
  eyebrowNode.textContent = eyebrow;

  const heading = document.createElement('h4');
  heading.className = 'mega-menu-featured__title';
  heading.textContent = title;

  const text = document.createElement('p');
  text.className = 'mega-menu-featured__text';
  text.textContent = body;

  const cta = document.createElement('a');
  cta.className = 'mega-menu-featured__cta';
  cta.setAttribute('href', ctaUrl);
  if (isExternalUrl(ctaUrl)) {
    cta.setAttribute('target', '_blank');
    cta.setAttribute('rel', 'noopener noreferrer');
  }
  const ctaLabelNode = document.createElement('span');
  ctaLabelNode.textContent = ctaLabel;
  cta.appendChild(ctaLabelNode);

  const ctaIcon = document.createElement('i');
  ctaIcon.setAttribute('data-lucide', 'arrow-right');
  ctaIcon.className = 'h-4 w-4';
  ctaIcon.setAttribute('aria-hidden', 'true');
  cta.appendChild(ctaIcon);

  content.appendChild(eyebrowNode);
  content.appendChild(heading);
  content.appendChild(text);

  ctaWrap.appendChild(cta);

  card.appendChild(media);
  card.appendChild(content);
  card.appendChild(ctaWrap);

  return card;
};

const buildAuxiliaryEntries = (sectionKey) => {
  if (sectionKey !== 'about' || ABOUT_FREE_CALL_URL === '') {
    return [];
  }

  const item = document.createElement('li');
  item.className = 'menu-item menu-item-type-custom menu-item-object-custom mega-menu-entry mega-menu-entry--aux';

  const link = document.createElement('a');
  link.className = 'mega-menu-entry-link';
  link.setAttribute('href', ABOUT_FREE_CALL_URL);
  if (isExternalUrl(ABOUT_FREE_CALL_URL)) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  }
  link.dataset.megaIcon = 'call';
  link.textContent = ABOUT_FREE_CALL_LABEL;

  item.appendChild(link);

  return [item];
};

const buildLinksColumn = (entryNodes, sectionKey) => {
  const column = document.createElement('li');
  column.className = 'mega-menu-column mega-menu-column--links';

  const list = document.createElement('ul');
  list.className = 'mega-menu-links-grid';

  if (sectionKey === 'locations') {
    list.classList.add('mega-menu-links-grid--locations');
  }

  entryNodes.forEach((node) => {
    list.appendChild(node);
  });

  column.appendChild(list);

  return column;
};

const syncMegaMenuTopOffset = () => {
  const rootStyle = document.documentElement.style;
  const header = document.querySelector('.header-industrial[data-site-header]');

  if (!header) {
    rootStyle.removeProperty('--mega-menu-top');
    return;
  }

  const headerBottom = Math.max(Math.round(header.getBoundingClientRect().bottom), 0);
  rootStyle.setProperty('--mega-menu-top', `${headerBottom}px`);
};

const setHeaderMegaState = (isOpen) => {
  const header = document.querySelector('.header-industrial[data-site-header]');

  if (!header) {
    return;
  }

  header.classList.toggle('is-mega-active', isOpen);
};

const closeOpenMegaMenus = () => {
  const openItems = document.querySelectorAll('.nav-desktop[data-mega-nav] .menu-item-has-children.mega-trigger.is-mega-open');

  openItems.forEach((item) => {
    item.classList.remove('is-mega-open');
    const trigger = item.querySelector(':scope > a.mega-trigger-link');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  });

  setHeaderMegaState(false);
};

let outsideEventsBound = false;
let megaOffsetEventsBound = false;

export default function registerMegaMenu(Alpine) {
  const bindMegaMenu = () => {
    const desktopNav = document.querySelector('.nav-desktop[data-mega-nav]');

    if (!desktopNav) {
      return;
    }

    const megaItems = desktopNav.querySelectorAll(':scope > #main-menu > ul > .menu-item-has-children.mega-trigger');
    const topLevelItems = desktopNav.querySelectorAll(':scope > #main-menu > ul > .menu-item');

    if (!megaItems.length) {
      return;
    }

    syncMegaMenuTopOffset();

    if (!megaOffsetEventsBound) {
      megaOffsetEventsBound = true;
      window.addEventListener('resize', syncMegaMenuTopOffset, { passive: true });
    }

    const closeAll = (exceptItem = null) => {
      megaItems.forEach((item) => {
        if (exceptItem && item === exceptItem) {
          return;
        }

        const itemTrigger = item.querySelector(':scope > a.mega-trigger-link');

        if (!itemTrigger) {
          return;
        }

        item.classList.remove('is-mega-open');
        itemTrigger.setAttribute('aria-expanded', 'false');
      });

      if (!exceptItem) {
        setHeaderMegaState(false);
      }
    };

    const closeTimers = new WeakMap();

    const syncPanelVariant = (menuItem, trigger, panel) => {
      const sectionUrl = trigger.dataset.megaLink || trigger.getAttribute('href') || '#';
      const sectionPath = getPathFromUrl(sectionUrl);
      const sectionKey = resolveSectionKeyFromUrl(sectionUrl);
      const entryNodes = panel.dataset.megaLayoutReady === 'true'
        ? Array.from(panel.querySelectorAll('.mega-menu-entry'))
        : Array.from(panel.children).filter((child) => (
          !child.classList?.contains('mega-menu-intro') && !child.classList?.contains('mega-menu-featured')
        ));
      const storedEntryCount = Number.parseInt(panel.dataset.megaEntryCount || '', 10);
      const entryCount = Number.isNaN(storedEntryCount) ? entryNodes.length : storedEntryCount;

      const isCompactMenu = entryCount <= 2 && sectionKey !== 'about';

      panel.classList.toggle('mega-dropdown--compact', isCompactMenu);
      panel.classList.toggle('mega-dropdown--services', sectionKey === 'services' && !isCompactMenu);
      panel.classList.toggle('mega-dropdown--locations', sectionKey === 'locations' && !isCompactMenu);
      menuItem.classList.toggle('mega-trigger-compact', isCompactMenu);

      return {
        entryNodes,
        entryCount,
        sectionKey,
        sectionPath,
        sectionUrl,
      };
    };

    const ensurePanelLayout = (menuItem, trigger, panel) => {
      const variant = syncPanelVariant(menuItem, trigger, panel);

      if (panel.dataset.megaLayoutReady === 'true') {
        return;
      }

      const title = (trigger.dataset.megaTitle || trigger.textContent || '').trim();
      const sectionConfig = resolveSectionConfig(variant.sectionKey, title, variant.sectionUrl);
      const allEntryNodes = [...variant.entryNodes, ...buildAuxiliaryEntries(variant.sectionKey)];

      panel.classList.add('mega-menu-panel');
      panel.dataset.megaEntryCount = String(allEntryNodes.length);
      panel.classList.toggle('mega-dropdown--no-featured', !sectionConfig.showFeatured);

      allEntryNodes.forEach((child) => {
        child.classList.add('mega-menu-entry');

        const link = child.querySelector(':scope > a');
        if (link) {
          link.classList.add('mega-menu-entry-link');
          decorateEntryLink(link, variant.sectionKey);
        }
      });

      panel.innerHTML = '';

      const intro = buildIntroNode({
        ...sectionConfig.intro,
      });

      panel.appendChild(intro);

      if (panel.classList.contains('mega-dropdown--compact')) {
        allEntryNodes.forEach((node) => {
          panel.appendChild(node);
        });
      } else {
        const linksColumn = buildLinksColumn(allEntryNodes, variant.sectionKey);

        panel.appendChild(linksColumn);

        if (sectionConfig.showFeatured) {
          const featuredCard = buildFeaturedNode(sectionConfig.featured);
          panel.appendChild(featuredCard);
        }
      }

      panel.dataset.megaLayoutReady = 'true';
    };

    const cancelScheduledClose = (menuItem) => {
      const timer = closeTimers.get(menuItem);

      if (!timer) {
        return;
      }

      clearTimeout(timer);
      closeTimers.delete(menuItem);
    };

    const scheduleClose = (menuItem, trigger, delay = 420) => {
      cancelScheduledClose(menuItem);

      const timer = window.setTimeout(() => {
        const panel = menuItem.querySelector(':scope > .mega-dropdown');

        if (menuItem.matches(':hover') || panel?.matches(':hover')) {
          return;
        }

        closeItem(menuItem, trigger);
        closeTimers.delete(menuItem);
      }, delay);

      closeTimers.set(menuItem, timer);
    };

    const openItem = (menuItem, trigger) => {
      syncMegaMenuTopOffset();
      closeAll(menuItem);
      menuItem.classList.add('is-mega-open');
      trigger.setAttribute('aria-expanded', 'true');
      setHeaderMegaState(true);
    };

    const closeItem = (menuItem, trigger) => {
      menuItem.classList.remove('is-mega-open');
      trigger.setAttribute('aria-expanded', 'false');
      const hasOpenMenus = document.querySelector('.nav-desktop[data-mega-nav] .menu-item-has-children.mega-trigger.is-mega-open');
      setHeaderMegaState(Boolean(hasOpenMenus));
    };

    megaItems.forEach((menuItem) => {
      const trigger = menuItem.querySelector(':scope > a.mega-trigger-link');
      const panel = menuItem.querySelector(':scope > .mega-dropdown');

      if (!trigger || !panel) {
        return;
      }

      if (menuItem.dataset.megaBound === 'true') {
        return;
      }

      ensurePanelLayout(menuItem, trigger, panel);

      menuItem.dataset.megaBound = 'true';
      trigger.setAttribute('aria-expanded', 'false');

      menuItem.addEventListener('mouseenter', () => {
        cancelScheduledClose(menuItem);
        openItem(menuItem, trigger);
      });

      menuItem.addEventListener('mouseleave', (event) => {
        const nextTarget = event.relatedTarget;

        if (nextTarget && (menuItem.contains(nextTarget) || panel.contains(nextTarget))) {
          return;
        }

        scheduleClose(menuItem, trigger, 340);
      });

      panel.addEventListener('mouseenter', () => {
        cancelScheduledClose(menuItem);
        openItem(menuItem, trigger);
      });

      panel.addEventListener('mouseleave', (event) => {
        const nextTarget = event.relatedTarget;

        if (nextTarget && menuItem.contains(nextTarget)) {
          return;
        }

        scheduleClose(menuItem, trigger, 240);
      });

      panel.addEventListener('wheel', () => {
        cancelScheduledClose(menuItem);
      }, { passive: true });

      panel.addEventListener('mousemove', () => {
        cancelScheduledClose(menuItem);
      });

      trigger.addEventListener('focus', () => {
        cancelScheduledClose(menuItem);
        openItem(menuItem, trigger);
      });

      menuItem.addEventListener('focusout', (event) => {
        if (!menuItem.contains(event.relatedTarget)) {
          closeItem(menuItem, trigger);
        }
      });

      trigger.addEventListener('click', (event) => {
        const hasTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

        if (!hasTouch) {
          return;
        }

        if (!menuItem.classList.contains('is-mega-open')) {
          event.preventDefault();
          cancelScheduledClose(menuItem);
          openItem(menuItem, trigger);
        }
      });
    });

    topLevelItems.forEach((menuItem) => {
      if (menuItem.classList.contains('mega-trigger')) {
        return;
      }

      if (menuItem.dataset.megaCloseBound === 'true') {
        return;
      }

      menuItem.dataset.megaCloseBound = 'true';

      menuItem.addEventListener('mouseenter', () => {
        closeAll();
      });

      menuItem.addEventListener('focusin', () => {
        closeAll();
      });
    });

    if (!outsideEventsBound) {
      outsideEventsBound = true;
      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Node)) {
          return;
        }

        const navs = document.querySelectorAll('.nav-desktop[data-mega-nav]');
        for (const nav of navs) {
          if (nav.contains(event.target)) {
            return;
          }
        }

        closeOpenMegaMenus();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
          return;
        }

        closeOpenMegaMenus();
      });
    }
  };

  bindMegaMenu();

  document.addEventListener('turbo:load', () => {
    bindMegaMenu();
  });
}
